import type { StaffLeaveType } from '../types/hrmsLeaveRequests.types'

interface LeaveTypeLabelProps {
  leaveType: StaffLeaveType
}

export function LeaveTypeLabel({ leaveType }: LeaveTypeLabelProps) {
  return (
    <span className="text-xs font-semibold text-slate-800 whitespace-nowrap">
      {leaveType}
    </span>
  )
}
